export default __webpack_public_path__ + "static/src/assets/images/icons/trade_icon_amend_normal.png";